import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { GetTokenByTicket } from "./api/index";
import Antd from "ant-design-vue";
import { message } from "ant-design-vue";
import "ant-design-vue/dist/antd.less";
import axios from "axios";
import BreadCrumb from "./components/ViewTitle.vue";
import RecallBack from "./components/RecallBack.vue";
import Reject from "./components/Reject.vue";
import ApplyOnOK from "./components/ApplyOnOK.vue";
import {cachePage} from '@/utils/routerCach'

import "./style/index.less";

router.beforeEach(async (to, from, next) => {
  store.dispatch("setLoading", true);
  // todo:登录验证
  let Url = "";
  if (
    process.env.VUE_APP_BUILD == "test" ||
    process.env.NODE_ENV == "development"
  ) {
    const testUlr = "http://graystaff.risfond.com/signin.aspx";
    Url = testUlr;
  } else {
    const formalUlr = "https://staff.risfond.com/signin.aspx";
    Url = formalUlr;
  }
  if (to.query.ticket) {
    const { Success, Data, Message } = await GetTokenByTicket(
      to.query.ticket as string
    );
    if (Success) {
      sessionStorage.setItem("token", `Bearer ${Data}`);
    } else {
      message.warning(Message);
    }
    const getSession = sessionStorage.getItem("token");
    if (!getSession) {
      message.warning("登录态失效，即将跳转登录页");
      window.location.href = Url;
    }
  } else if (!sessionStorage.getItem("token")) {
    message.warning("登录态失效，即将跳转登录页");
    window.location.href = Url;
  }
  store.dispatch("setLogin", true);
  cachePage(to,from)  // 判断列表页缓存
  next();
});

router.afterEach(async () => {
  if (store.getters.getLoadingStatus) {
    setTimeout(() => {
      store.dispatch("setLoading", false);
    }, 220);
  }
  return true;
});

const app = createApp(App);
app.config.warnHandler = () => null


import mitt from "mitt"
app.config.globalProperties.$bus = mitt()

app
  .use(store)
  .use(Antd)
  .use(router)
  .component("BreadCrumb", BreadCrumb)
  .component("RecallBack", RecallBack)
  .component("Reject", Reject)
  .component("ApplyOnOK", ApplyOnOK)
  .mount("#app");
